import { createSection } from '../createSection'

/**
 * Prefix section
 *
 * @public
 */
export const prefix = createSection('prefix', null)
